import { render, staticRenderFns } from "./AccountDetails.vue?vue&type=template&id=05705f01"
import script from "./AccountDetails.vue?vue&type=script&lang=js"
export * from "./AccountDetails.vue?vue&type=script&lang=js"
import style0 from "./AccountDetails.vue?vue&type=style&index=0&id=05705f01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports